import { Minimize2, SquarePen } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { GeneralAgentBody } from '../components/GeneralAgentBody'
import { GeneralAgentHeaderButton } from '../components/GeneralAgentHeaderButton'
import { GeneralAgentHistoryButton } from '../components/GeneralAgentHistoryButton'
import { GENERAL_AGENT_FALLBACK_PATH } from '../constants'
import { useGeneralAgentChatStore } from '../hooks/generalAgentChatStore'

/** react-router keeps the history index in `history.state.idx`; above 0 there is a page in this app to go back to. */
function canGoBack(): boolean {
    const state = window.history.state as { idx?: number } | null
    return (state?.idx ?? 0) > 0
}

/** The general agent's chat (ADR-048) as a full page. Minimizing goes back to the last page with the panel open. */
export const GeneralAgentPage = () => {
    const navigate = useNavigate()
    const setPanelOpen = useGeneralAgentChatStore((s) => s.setPanelOpen)
    const reset = useGeneralAgentChatStore((s) => s.reset)
    const empty = useGeneralAgentChatStore((s) => s.messages.length === 0)

    const minimize = () => {
        setPanelOpen(true)
        if (canGoBack()) navigate(-1)
        else navigate(GENERAL_AGENT_FALLBACK_PATH)
    }

    return (
        <div className="flex h-full min-h-0 flex-col bg-background p-4 text-foreground">
            <div className="mx-auto flex h-full min-h-0 w-full max-w-3xl flex-col gap-4 rounded-2xl bg-surface p-4 shadow-surface">
                <header className="flex items-center justify-between gap-2">
                    <h1 className="text-xl font-semibold">General agent</h1>
                    <div className="flex items-center gap-1">
                        <GeneralAgentHistoryButton />
                        <GeneralAgentHeaderButton label="New chat" onClick={reset} disabled={empty}>
                            <SquarePen className="h-4 w-4" />
                        </GeneralAgentHeaderButton>
                        <GeneralAgentHeaderButton label="Minimize" onClick={minimize}>
                            <Minimize2 className="h-4 w-4" />
                        </GeneralAgentHeaderButton>
                    </div>
                </header>
                <GeneralAgentBody />
            </div>
        </div>
    )
}
